'use client';
import * as Api from "@api";
// import { useState } from 'react';
import faq from '../../styles/modules/faq.module.scss';
import React from "react";

export default function FAQ({ item }: { item: Api.FAQ })
{
    const [isExpanded, setIsActive] = React.useState(false);

    return (
        <div className={`${faq.faq_item} ${isExpanded ? 'opened' : 'closed'}`}>
            <button type={"button"}
                    className={`faq-question py-5 ${faq.faq_question}`}
                    aria-expanded={isExpanded}
                    aria-controls={item.id}
                    aria-label={(isExpanded ? "hide answer" : "show answer")}
                    dangerouslySetInnerHTML={{ __html: item.question }}
                    onClick={() => setIsActive(!isExpanded)}></button>
            <div className={`faq-answer pt-3 ${faq.faq_answer}`} id={item.id} dangerouslySetInnerHTML={{ __html: item.answer }}></div>
        </div>
    )
}